/**
 * auditLog — Sprint 2 (F5E-004, F5A-002, F5B-004)
 *
 * Helper para registrar operaciones sensibles en la colección `auditoria`.
 * Las reglas Firestore deben permitir escritura solo desde Cloud Functions
 * (o en su defecto, desde ADMIN con rules laxas durante transición).
 *
 * Uso:
 *   await logAudit({
 *     action: 'delete',
 *     collection: 'propiedades',
 *     docId: '123',
 *     userId: user.id,
 *     userEmail: user.correo,
 *     metadata: { reason: 'duplicada' }
 *   });
 */

import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebaseConfig';

export type AuditAction =
  | 'create'
  | 'update'
  | 'delete'
  | 'soft_delete'
  | 'restore'
  | 'approve'
  | 'reject'
  | 'bulk_operation'
  | 'login'
  | 'password_reset'
  | 'role_change'
  | 'export'
  | 'import';

export interface AuditEntry {
  action: AuditAction;
  collection: string;
  docId?: string;
  userId?: string;
  userEmail?: string;
  userRol?: string;
  before?: any;
  after?: any;
  metadata?: Record<string, any>;
}

/**
 * Registra una entrada de auditoría. No lanza error al llamador si falla
 * (audit nunca debe bloquear la operación principal).
 */
export async function logAudit(entry: AuditEntry): Promise<void> {
  try {
    await addDoc(collection(db, 'auditoria'), {
      ...entry,
      timestamp: serverTimestamp(),
      userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : undefined,
    });
  } catch (e) {
    if (process.env.NODE_ENV === 'development') {
      console.error('[auditLog] fallo registrando entrada:', e);
    }
  }
}

export default logAudit;
